
//Valida si le llegan las Notificaciones a un Usuario especifico
export const validateConfigurationsUserProfile = (id_usuario, id_notificacion_tipo) => {
    return new Promise((resolve, reject) => {
        let url = process.env.REACT_APP_PUBLIC_URL + `notificacion-configuracion/consultar?notificacion_tipo=${id_notificacion_tipo}&id_usuario=${id_usuario}`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error en el servidor');
            }
        }).then((data) => {
            resolve(data);
        }).catch((err) => {
            reject(err);
        });
    });
}

//Trae los Usuarios pertenecientes a un Tipo de Notificacion
export const validateConfigurationsTypeNotification = (id_notificacion_tipo) => {
    return new Promise((resolve, reject) => {
        let url = process.env.REACT_APP_PUBLIC_URL + `notificacion-configuracion/consultar-x-tipo?notificacion_tipo=${id_notificacion_tipo}`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else 
            {
                throw new Error('Ha ocurrido un error en el servidor');
            }
        }).then((data) => {
            resolve(data);
        }).catch((err) => {
            reject(err);
        });
    });
}